module.exports = __webpack_public_path__ + "static/media/kids_op_het_strand.130ab3f5.jpg";